var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex justify-end"},[_c('a',{staticClass:"mr-2",attrs:{"href":`/panels/floors/${_vm.uuid}`}},[_c('button-secondary',[_c('template',{slot:"icon"},[_c('i',{staticClass:"fa fa-television"})]),_vm._v("\n              Monitor anzeigen\n          ")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }